var publicPath = '%%%PUBLIC_URL%%%';

if (!new RegExp('%%%\\w+%%%').test(publicPath)) {
	publicPath = publicPath.endsWith('/') ? publicPath : `${publicPath}/`;

	// eslint-disable-next-line no-undef
	__webpack_public_path__ = publicPath;
}
